import * as React from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { commonProps, CommonProps } from '@bestyled/system'
import styled from 'styled-components'

const AnimateGroup = AnimatePresence

export { AnimateGroup }

export interface AnimatedProps extends CommonProps {
  pose?: string
  initialPose?: string
  style?: any
  as?: string | React.FC<any>
  [key: string]: any
}

const AnimatedBase = React.forwardRef(
  (props: React.PropsWithChildren<AnimatedProps>, innerRef: any) => {
    const { as, children, style, className, ...rest } = props
    return React.createElement(
      as || motion.div,
      { className, ref: innerRef, style, itemType: 'Animated', ...rest },
      props.children
    )
  }
)

AnimatedBase.displayName = 'Animated'

const StyledAnimated = styled(AnimatedBase)`
  display: block;
  align-items: inherit;
  box-sizing: inherit;
  flex-basis: inherit;
  flex-direction: inherit;
  flex-shrink: inherit;
  align-content: inherit;
  justify-content: inherit;
  align-items: inherit;
  z-index: inherit;
  margin: 0;
  padding: 0;
  min-height: 0;
  min-width: 0;
  ${commonProps}
`

export function AnimatedWithPoses<T extends AnimatedProps>(poses: any) {
  const { initial, animate, exit, ...variants } = poses

  return (((props) => (
    <Animated
      animate={animate}
      initial={initial}
      exit={exit}
      variants={variants}
      {...props}
    />
  )) as any) as React.FC<T>
}

export function Animated<T extends AnimatedProps>(props: T) {
  const { initial, pose, initialPose, animate, exit, ...rest } = props

  return (
    <StyledAnimated
      animate={pose || animate}
      initial={initialPose || initial}
      exit={exit}
      {...rest}
    />
  )
}
